import {
  MainSidebarMenu,
  QualityMenu,
  ProjectConfigMenu,
  ToolsMenu,
  FinanceTabs,
  ChatTaskMenu,
  ThroughputMenu,
  BenchmarkCenterTabs,
  PipelineTabs,
  TrainingMenu,
  COMMUNITY_MANAGEMENT,
  COMMUNITY_MANAGEMENT_SLACK_CHANNEL,
  TRUST_AND_SAFETY_CENTER,
  TRUST_AND_SAFETY_SLACK_CHANNEL,
} from 'react-scale/corp/views/CorpProjectGroupManager/constants';
import { MenuItemProps } from '@scale/scaleui';
import { WORKER_MANAGER } from 'react-scale/components/ExpertManagement/constants';
import { GROWTH_CENTER_DASHBOARD } from 'react-scale/components/GrowthCenter/constants';
import { POD_LEAD_CENTER } from 'react-scale/components/PodLeadCenter/constants';

const genaiOpsHubSlackItem: MenuItemProps = {
  label: 'Slack #genai-ops-hub',
  href: 'https://scale.enterprise.slack.com/archives/C05EJ62EZK4',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiBillingHubSlackItem: MenuItemProps = {
  label: 'Slack #genai-billing-hub-public',
  href: 'https://scale.enterprise.slack.com/archives/C07HL5GN9B8',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const billingProposalWikiItem: MenuItemProps = {
  label: 'Billing Proposal Wiki',
  href: 'https://scale.atlassian.net/wiki/spaces/OP/pages/1059848210/Setting+Up+Project+Billing',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const billingHubWikiItem: MenuItemProps = {
  label: 'Billing Hub Wiki',
  href: 'https://scale.atlassian.net/wiki/spaces/OP/pages/1149829124/Billing+Hub',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiChatTaskOpsSlackItem: MenuItemProps = {
  label: 'Slack #genai-chat-task-ops',
  href: 'https://scale.enterprise.slack.com/archives/C05P745UG1Y',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const activationControlPanelSlackItem: MenuItemProps = {
  label: 'Slack #activation-control-panel',
  href: 'https://scale.enterprise.slack.com/archives/C073BUY5ZPF',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const squadCbSuccessSlackItem: MenuItemProps = {
  label: 'Slack #squads-cb-success',
  href: 'https://scale.enterprise.slack.com/archives/C06M66SH2CW',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiQualityTeamSlackItem: MenuItemProps = {
  label: 'Slack #genai-quality-team',
  href: 'https://scale.enterprise.slack.com/archives/C06FYDY3YS3',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiLinterSlackItem: MenuItemProps = {
  label: 'Slack #genai-linters',
  href: 'https://scale.enterprise.slack.com/archives/C05UDKYQD9Q',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const reviewerHubSprintSlackItem: MenuItemProps = {
  label: 'Slack #reviewer-hub-sprint',
  href: 'https://scale.enterprise.slack.com/archives/C074XQXEC1E',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiBenchmarksSlackItem: MenuItemProps = {
  label: 'Slack #genai-benchmarks',
  href: 'https://scale.enterprise.slack.com/archives/C05PH5U1WBZ',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const squadsOpsSlackItem: MenuItemProps = {
  label: 'Slack #squads-ops',
  href: 'https://scale.enterprise.slack.com/archives/C08A18PT2SX',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiDeliveryHubSlackItem: MenuItemProps = {
  label: 'Slack #genai-delivery-hub',
  href: 'https://scale.enterprise.slack.com/archives/C06N79SHVBR',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiAllocationEngExternalSlackItem: MenuItemProps = {
  label: 'Slack #genai-allocation-eng-external',
  href: 'https://scale.enterprise.slack.com/archives/C06JFK7B6SW',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiCodingEngSlackItem: MenuItemProps = {
  label: 'Slack #genai-coding-eng',
  href: 'https://scale.enterprise.slack.com/archives/C063BJ9M325',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiPayInternalSlackItem: MenuItemProps = {
  label: 'Slack #pay-internal',
  href: 'https://scale.enterprise.slack.com/archives/C05J8CH27JT',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiCheatingInitiativeSlackItem: MenuItemProps = {
  label: 'Slack #genai-cheating-initiative',
  href: 'https://scale.enterprise.slack.com/archives/C05V3PQJVR6',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const taskPipelineV3OpsRequestsSlackItem: MenuItemProps = {
  label: 'Slack #task-pipeline-v3-ops-requests',
  href: 'https://scale.enterprise.slack.com/archives/C04JF0ER32R',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiEqFeedbackSlackItem: MenuItemProps = {
  label: 'Slack #genai-eq-feedback',
  href: 'https://scale.enterprise.slack.com/archives/C07AB40ETMF',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const growthEngExternalSlackItem: MenuItemProps = {
  label: 'Slack #growth-eng-external',
  href: 'https://scale.enterprise.slack.com/archives/C06DD6GPRPG',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const bleedingProjectCostsAlertsSlackItem: MenuItemProps = {
  label: 'Slack #bleeding-project-costs-alerts',
  href: 'https://scale.enterprise.slack.com/archives/C06TBSRN97H',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const slackCommunitiesEngSlackItem: MenuItemProps = {
  label: `Slack ${COMMUNITY_MANAGEMENT_SLACK_CHANNEL}`,
  href: 'https://scale.enterprise.slack.com/archives/C06MHHZA05Q',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const trustAndSafetyEngSlackItem: MenuItemProps = {
  label: `Slack ${TRUST_AND_SAFETY_SLACK_CHANNEL}`,
  href: 'https://scale.enterprise.slack.com/archives/C05ATKPRNQ4',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const genaiDiversitySlackItem: MenuItemProps = {
  label: 'Slack #genai-diversity',
  href: 'https://scale.enterprise.slack.com/archives/C05FWNN58R4',
  target: '_blank',
  icon: 'external-link-alt' as const,
};

const viewInCorpQMQueueItem: (projectId: string, path?: string) => MenuItemProps = (
  projectId,
  path,
) => ({
  label: 'View in Corp',
  href: path
    ? `https://dashboard.scale.com/corp/qm/queue/${projectId}/${path}`
    : `https://dashboard.scale.com/corp/qm/queue/${projectId}`,
  target: '_blank',
  icon: 'external-link-alt' as const,
});

const viewInCorpItem: (path: string) => MenuItemProps = path => ({
  label: 'View in Corp',
  href: `https://dashboard.scale.com/corp/${path}`,
  target: '_blank',
  icon: 'external-link-alt' as const,
});

const documentationItem: (url: string) => MenuItemProps = url => ({
  label: 'Documentation',
  href: url,
  target: '_blank',
  icon: 'book-blank' as const,
});

const redashQueryItem: (url: string) => MenuItemProps = url => ({
  label: 'View Query in Redash',
  href: url,
  target: '_blank',
  icon: 'external-link-alt' as const,
});

export const getViewMenuItems = ({
  view,
  projectId = '',
  dateRange = ['', ''],
}: {
  view: string;
  projectId?: string;
  dateRange?: string[];
}): MenuItemProps[] => {
  const menuItemsPerView: Record<string, MenuItemProps[]> = {
    [MainSidebarMenu.Overview]: [genaiOpsHubSlackItem, viewInCorpQMQueueItem(projectId)],
    [ChatTaskMenu.Taxonomy]: [
      genaiChatTaskOpsSlackItem,
      viewInCorpQMQueueItem(projectId, 'templates'),
    ],
    [ChatTaskMenu.Config]: [genaiChatTaskOpsSlackItem, viewInCorpQMQueueItem(projectId, 'config')],
    [TrainingMenu.ActivationControlPanel]: [
      activationControlPanelSlackItem,
      viewInCorpQMQueueItem(projectId, 'training'),
    ],
    [TrainingMenu.Instructions]: [genaiQualityTeamSlackItem],
    [TrainingMenu.Courses]: [genaiQualityTeamSlackItem],
    [TrainingMenu.WebinarSessions]: [genaiQualityTeamSlackItem],
    [TrainingMenu.TaskPreview]: [
      genaiQualityTeamSlackItem,
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/OP/pages/1469743112/Contributor+Task+Preview',
      ),
    ],
    [ThroughputMenu.PipelineSnapshot]: [genaiOpsHubSlackItem, viewInCorpQMQueueItem(projectId)],
    [PipelineTabs.Editor]: [genaiChatTaskOpsSlackItem, viewInCorpQMQueueItem(projectId, 'config')],
    [MainSidebarMenu.Quality]: [genaiQualityTeamSlackItem, viewInCorpQMQueueItem(projectId)],
    [MainSidebarMenu.Billing]: [
      genaiBillingHubSlackItem,
      billingProposalWikiItem,
      billingHubWikiItem,
    ],
    [MainSidebarMenu.Linters]: [genaiLinterSlackItem, viewInCorpQMQueueItem(projectId)],
    [FinanceTabs.FinanceReport]: [
      genaiOpsHubSlackItem,
      redashQueryItem(
        `https://redash.scale.com/queries/126290/source?p_from_date=${dateRange?.[0]}&p_project_id=${projectId}&p_to_date=${dateRange?.[1]}`,
      ),
    ],
    [FinanceTabs.FinanceRequests]: [genaiOpsHubSlackItem],
    [FinanceTabs.PaySandbox]: [
      genaiOpsHubSlackItem,
      viewInCorpQMQueueItem(projectId, 'paySandbox'),
    ],
    [FinanceTabs.StellarQualityIncentives]: [
      genaiOpsHubSlackItem,
      viewInCorpQMQueueItem(projectId, 'incentives'),
    ],
    [FinanceTabs.CostCenter]: [genaiOpsHubSlackItem],
    [FinanceTabs.PausedHistory]: [genaiOpsHubSlackItem],
    [QualityMenu.Reviewers]: [
      documentationItem('https://scale.atlassian.net/wiki/spaces/OP/pages/936378428/Reviewer+Hub'),
      reviewerHubSprintSlackItem,
      viewInCorpQMQueueItem(projectId),
    ],
    [QualityMenu.BenchmarkCenter]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/OP/pages/943620132/Benchmarks+Documentation',
      ),
      genaiBenchmarksSlackItem,
      viewInCorpQMQueueItem(projectId, 'benchmarks'),
    ],
    [QualityMenu.Diversity]: [
      documentationItem(
        'https://docs.google.com/document/d/1Kq6L4d4JWccheK1dDe8hBfDbK2ynOPMuSGaj2B6YLKE/view',
      ),
      genaiDiversitySlackItem,
    ],
    [BenchmarkCenterTabs.Config]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/OP/pages/943620132/Benchmarks+Documentation',
      ),
      genaiBenchmarksSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [MainSidebarMenu.DeliveryHub]: [genaiDeliveryHubSlackItem],
    [ProjectConfigMenu.AllocationAndQualifications]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/OP/pages/861405186/Qualification+Lists',
      ),
      genaiAllocationEngExternalSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.OffPlatform]: [
      genaiAllocationEngExternalSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.QualityImprovement]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/EPD/pages/732102659/Quality+Improvement+Team+Home',
      ),
      genaiQualityTeamSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.QualityControl]: [
      genaiQualityTeamSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.SpecializedRouting]: [
      genaiAllocationEngExternalSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.TaskReplication]: [
      genaiCodingEngSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.TimersAndThrottling]: [
      documentationItem('https://scale.atlassian.net/wiki/spaces/OP/pages/991789057/Throttling'),
      genaiPayInternalSlackItem,
      genaiAllocationEngExternalSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [ProjectConfigMenu.AutoFeedback]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/OP/pages/801243137/Auto+Feedback+Chat+Companion',
      ),
      genaiLinterSlackItem,
      viewInCorpQMQueueItem(projectId, 'config'),
    ],
    [MainSidebarMenu.Jobs]: [genaiOpsHubSlackItem],
    [ToolsMenu.CheatingDetection]: [
      documentationItem(`https://scale.atlassian.net/wiki/spaces/OP/pages/563249197/Cheating`),
      genaiCheatingInitiativeSlackItem,
    ],
    [ToolsMenu.TaskActions]: [taskPipelineV3OpsRequestsSlackItem, viewInCorpItem('v3traits')],
    [ToolsMenu.LintersEval]: [
      documentationItem(
        `https://docs.google.com/document/d/1uu7EYp7JG0HTi_WR4-fTdfDkGnBkRDcATOlCcPdqTto/edit`,
      ),
      genaiLinterSlackItem,
    ],
    [ToolsMenu.ContributorRebirth]: [
      documentationItem(
        `https://scale.atlassian.net/wiki/spaces/OP/pages/1021607957/Contributor+Rebirth`,
      ),
      genaiBenchmarksSlackItem,
    ],
    [ToolsMenu.ExplainQueue]: [
      documentationItem(`https://scale.atlassian.net/wiki/spaces/OP/pages/839024643/Explain+Queue`),
      genaiEqFeedbackSlackItem,
    ],
    [ToolsMenu.SphereWorkspaceProvisioner]: [
      documentationItem(
        `https://scale.atlassian.net/wiki/spaces/OP/pages/485654533/Setting+up+Sphere+Engine+for+a+Coding+Project`,
      ),
      genaiCodingEngSlackItem,
    ],
    [ToolsMenu.ShareTasks]: [genaiOpsHubSlackItem],
    [ToolsMenu.ModelHealth]: [genaiOpsHubSlackItem],
    [WORKER_MANAGER]: [squadCbSuccessSlackItem],
    [GROWTH_CENTER_DASHBOARD]: [growthEngExternalSlackItem],
    [POD_LEAD_CENTER]: [bleedingProjectCostsAlertsSlackItem],
    [COMMUNITY_MANAGEMENT]: [
      documentationItem(
        'https://scale.atlassian.net/wiki/spaces/EPD/pages/872480794/Slack+Management+App',
      ),
      slackCommunitiesEngSlackItem,
    ],
    [TRUST_AND_SAFETY_CENTER]: [trustAndSafetyEngSlackItem],
    [MainSidebarMenu.Squads]: [
      documentationItem('https://scale.atlassian.net/wiki/spaces/OP/pages/1730347129/Squads'),
      squadsOpsSlackItem,
    ],
  };

  return menuItemsPerView[view] || [];
};
